export default __webpack_public_path__ + "resources/icons/d231-d3a1.png";